//@flow
/**
 * Client Actions
 * @module client/actions
 */
import ReactGA from "react-ga";
import localforage from "localforage";
import {
  FETCH_COURSE_REQUEST,
  FETCH_COURSE_PENDING,
  FETCH_COURSE_SUCCESS,
  FETCH_COURSE_FAILURE,
} from "./reducer";
import { getCourses } from "../../utils/api/course";

const courseStore = localforage.createInstance({
  name: "course",
});

// refetch the question from server just incase there is an update
/**
 * fetches client details
 * @memberof course/actions
 */
export const fetchCourses = () => async (dispatch: Function) => {
  dispatch({
    type: FETCH_COURSE_REQUEST,
  });
  // get the client from offline cache
  dispatch({
    type: FETCH_COURSE_PENDING,
    payload: await courseStore.getItem("details"),
  });

  try {
    const courses = await getCourses();
    courseStore.setItem("details", courses.data.data);
    dispatch({
      type: FETCH_COURSE_SUCCESS,
      payload: courses.data.data,
    });
  } catch (err) {
    return dispatch({
      type: FETCH_COURSE_FAILURE,
      payload: err,
      error: true,
    });
  }
};



// WEBPACK FOOTER //
// ./src/state/courses/actions.js